import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {toRefs, watch, ref, computed} from 'vue'
import {AgBoxS} from '@/components/ag'
import {debounce} from 'lodash'
import {useMutation} from '@vue/apollo-composable'
import {gql} from 'graphql-tag'
import {IonToggle} from '@ionic/vue'
import {useStore} from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const title = ref('푸시알림 수신 동의')
const description = ref('조합관리 관련 알림 받으시려면 동의해주세요.')
const {getters, dispatch, commit} = useStore()
const settingInfo = computed(() => getters['user/getSettingInfo'] ?? {})
const appPushAgreement = computed(() => Boolean(settingInfo.value.agreeAppPushAt))


const {mutate: updateAgree, onDone} = useMutation(gql`
    mutation ($value: Boolean!) {
        updateAgreeUserAppPush(isAgree: $value)
    }
`)


const value = ref(appPushAgreement.value)

watch(appPushAgreement, (_value) => {
  value.value = _value
})


const onChange = (event: any) => {
  value.value = event.target.checked
}


onDone((result) => {
  const {updateAgreeUserAppPush} = result.data
  value.value = updateAgreeUserAppPush
})



watch(value, debounce((value) => {
  updateAgree({
    value,
  })

}, 750))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), { css: {width: '100%', dp: 'flex', direction: 'row', py: 16} }, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), { css: {dp: 'flex', direction: 'column', grow: 1} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {typography: 'h7', color: 'font', fontWeight: 700} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(title.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'h10', color: '#8F929B'} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(description.value), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToggle), {
            mode: "ios",
            style: {'--background-checked': '#4360EC'},
            checked: value.value,
            onIonChange: onChange
          }, null, 8, ["checked"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})